import { formatDate } from '@/web-task/filter.js'
import { soFarDate } from '@/web-task/utils.js'
import { zeroUnit } from '@/web-task/utils.js'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const injuredSurvey =
		(injured &&
			(this.isLivingInvestigate
				? injured.homeInjuredSurvey
				: injured.workInjuredSurvey)) ||
		{}

	let arr = [
		{
			label: '被询问人姓名',
			value: injuredSurvey.intervieweeName,
		},
		{
			label: '被询问人电话',
			value: injuredSurvey.intervieweePhone,
		},
		{
			label: '被询问人与伤者关系',
			value: setting.relationTypeMap[injuredSurvey.relation],
		},
	]
	if (this.isWorkInvestigate) {
		arr.push(
			{
				label: '实际公司名称',
				value: injuredSurvey.injuredWorkCompany,
			},
			{
				label: '公司所在地区',
				value: injuredSurvey.areaDesc,
			},
			{
				label: '详细地址',
				value: injuredSurvey.address,
			},
			{
				label: '公司性质',
				value: setting.companyTypeMap[injuredSurvey.companyType],
			},
			{
				label: '是否有合同',
				value: setting.contractTypeMap[injuredSurvey.contractType],
			},
			{
				label: '入职时间',
				value: formatDate(injuredSurvey.beginTime),
			},
			{
				label: '所属部门',
				value: injuredSurvey.department,
			},
			{
				label: '工作岗位',
				value: injuredSurvey.jobName,
			},
			{
				label: '工资收入组成',
				value: injuredSurvey.wageForm,
			},
			{
				label: '工资收入（月）',
				value: zeroUnit(injuredSurvey.wage, '元/月'),
			},
			{
				label: '工资发放形式',
				value: setting.wageTypeMap[injuredSurvey.wageType],
			},
			{
				label: '是否缴纳社保',
				value: setting.yesNoMap[injuredSurvey.socialSecurity],
			},
			{
				label: '是否缴纳公积金',
				value: setting.yesNoMap[injuredSurvey.accumulationFund],
			},
			{
				label: '请假类型',
				value: setting.leaveTypeMap[injuredSurvey.leaveType],
			},
			{
				label: '因事故请假后扣减金额',
				value: zeroUnit(injuredSurvey.leaveLossAmount, '元'),
			}
		)
	}
	if (this.isLivingInvestigate) {
		arr.push(
			{
				label: '伤者住房类型',
				value: setting.houseTypeMap[injuredSurvey.houseType],
			},
			{
				label: '居住开始时间',
				value: formatDate(injuredSurvey.beginTime),
			},
			{
				label: '居住结束时间',
				value: soFarDate(injuredSurvey.endTime),
			},
			{
				label: '是否常住',
				value: setting.yesNoMap[injuredSurvey.regular],
			},
			{
				label: '是否有同住人',
				value: setting.yesNoMap[injuredSurvey.hasTogether],
			}
		)
		if (injuredSurvey.togethers && injuredSurvey.togethers.length > 0) {
			if (injuredSurvey.togethers.length > 1) {
				injuredSurvey.togethers.forEach((item, key) => {
					arr.push(
						{
							label: `同住人姓名${key + 1}`,
							value: item.name,
						},
						{
							label: `同住人电话${key + 1}`,
							value: item.phone,
						},
						{
							label: `同住人与伤者关系`,
							value: item.relation,
						}
					)
				})
			} else {
				let together = injuredSurvey.togethers[0]
				arr.push(
					{
						label: `同住人姓名`,
						value: together && together.name,
					},
					{
						label: `同住人电话`,
						value: together && together.phone,
					},
					{
						label: `同住人与伤者关系`,
						value: together && together.relation,
					}
				)
			}
		}
		arr.push(
			{
				label: '实际居住地区',
				value: injuredSurvey.areaDesc,
			},
			{
				label: '详细地址',
				value: injuredSurvey.address,
			}
		)
	}

	arr.push(
		{
			label: '是否签字',
			value: setting.yesNoMap[injuredSurvey.sign],
		},
		{
			label: '备注（非必填）',
			value: injuredSurvey.remark,
		}
	)

	return {
		title: '伤者/家属询问笔录',
		children: arr,
	}
}
